// @flow
import React from "react";
// $FlowFixMe
import loadable from "@loadable/component";
import ProgramPageMask from "@tvg/atomic-ui/_static/Masks/program-page";
import TracksPageMask from "@tvg/atomic-ui/_static/Masks/tracks";
import PicksPageMask from "@tvg/atomic-ui/_static/Masks/talent-picks";
import HomePageMask from "@tvg/atomic-ui/_static/Masks/homepage";
import URPProgramPageLoading from "@tvg/pp/src/Loading";
import { isURP } from "@tvg/utils/generalUtils";
import getPublicPath from "./utils/getPublicPath";

const Loading = (error, Mask) => {
  if (error) {
    try {
      window.onSplashLoadError();
    } catch (e) {
      console.error(e);
    }

    return false;
  }
  return (Mask && <Mask />) || <div />;
};

const publicPath = getPublicPath();

if (publicPath) {
  /* eslint-disable */
  // $FlowFixMe
  __webpack_public_path__ = publicPath;
  /* eslint-enable */
}

const ProgramPageLoading = () =>
  isURP ? <URPProgramPageLoading isMobile /> : <ProgramPageMask />;

export const ProgramPageLoadable = loadable(
  () => import(/* webpackChunkName: 'ProgramPage' */ "./components/Program"),
  {
    fallback: <ProgramPageLoading />
  }
);

export const TracksPageLoadable = loadable(
  () => import(/* webpackChunkName: 'tracksPage' */ "./components/Tracks"),
  {
    fallback: <TracksPageMask />
  }
);

export const TracksPageNewLoadable = loadable(
  () => import(/* webpackChunkName: 'tracksPage' */ "./components/TracksPage"),
  {
    fallback: <TracksPageMask />
  }
);

export const TutorialsPageLoadable = loadable(
  () => import(/* webpackChunkName: 'Tutorials' */ "./components/Tutorials"),
  {
    fallback: (props) => Loading(props.error, null)
  }
);

export const ResultsPageLoadable = loadable(
  () => import(/* webpackChunkName: 'Results' */ "./components/Results"),
  {
    fallback: <TracksPageMask />
  }
);

export const PicksPageLoadable = loadable(
  () => import(/* webpackChunkName: 'Picks' */ "./components/Picks"),
  {
    fallback: <PicksPageMask />
  }
);

export const MorePageLoadable = loadable(
  () => import(/* webpackChunkName: 'More' */ "./components/More"),
  {
    fallback: (props) => Loading(props.error, null)
  }
);

export const HomePageLoadable = loadable(
  () => import(/* webpackChunkName: 'Home' */ "./components/Home"),
  {
    fallback: <HomePageMask />
  }
);

export const LivePageLoadable = loadable(
  () => import(/* webpackChunkName: 'Live' */ "./components/Live"),
  {
    fallback: (props) => Loading(props.error, null)
  }
);

export const WagerRewardsLoadable = loadable(
  () =>
    import(/* webpackChunkName: 'WagerRewards' */ "./components/WagerRewards"),
  {
    fallback: (props) => Loading(props.error, null)
  }
);

export const EmailUnsubscribePageLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: 'EmailPreferences' */ "./components/EmailPreferences"
    ),
  {
    fallback: (props) => Loading(props.error, null)
  }
);

export const EmailSubscribePageLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: 'EmailPreferences' */ "./components/EmailPreferences"
    ),
  {
    fallback: (props) => Loading(props.error, null)
  }
);

export const RacetracksPageLoadable = loadable(
  () => import(/* webpackChunkName: 'Racetracks' */ "./components/Racetracks"),
  {
    fallback: (props) => Loading(props.error, null)
  }
);

export const RedirectEngineLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: 'RedirectEngine' */ "./components/RedirectEngine"
    ),
  {
    fallback: (props) => Loading(props.error, null)
  }
);

/** Preload most important pages * */
ProgramPageLoadable.preload();
